import { AuditLogRightSidebarAsync } from '@jira/admin-pages__product-jsm-ai-governance/src/AuditLogRightSidebarAsync.tsx';
import {
	composeLayouts,
	type Layout,
} from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';

/**
 * Compose the global settings layout with the shared audit log right sidebar.
 * Kept in a separate file (not at the route entry level) to defer evaluation and
 * avoid webpack null-loader issues during SSR route generation
 */
export const productsJsmRovoAiAuditLogsLayout: Layout = composeLayouts(globalSettingsLayout, {
	rightSidebars: [AuditLogRightSidebarAsync],
});

export default productsJsmRovoAiAuditLogsLayout;
